import { Typography } from '@neo/primitives/typography'
import {
  PhoneIncoming as PhoneIncomingIcon,
  PhoneOutgoing as PhoneOutgoingIcon,
  PhoneForwarded as PhoneTransferIcon,
  Users,
} from 'lucide-react'
import { usePhoneStore } from 'v2/state/phone'
import { CallDirection, ParticipantState } from 'v2/types/call'

interface CallTitleProps {
  isMinimized?: boolean
}

export const CallTitle = ({ isMinimized }: CallTitleProps) => {
  const { activeCall, participants } = usePhoneStore()
  const { meta, teamName, fromAgent } = activeCall?.extraHeaders || {}

  const isColdTransfer = participants?.some(
    (participant) => participant.state === ParticipantState.CONNECTING_COLD_TRANSFER,
  )

  const getCallTitle = () => {
    if (isColdTransfer)
      return (
        <div className="flex items-center gap-1">
          <PhoneTransferIcon className="h-4 w-4 text-brand-text" />
          {isMinimized ? null : <span>Transfer in progress...</span>}
        </div>
      )
    if (activeCall?.direction === CallDirection.OUTBOUND)
      return (
        <div className="flex items-center gap-1">
          <PhoneOutgoingIcon className="h-4 w-4 text-brand-text" />
          {isMinimized ? null : (
            <Typography variant="XS/400" className="text-secondary leading-4">
              Outgoing Call
            </Typography>
          )}
        </div>
      )
    if (meta === 'Incoming call transfer' || meta === 'Outgoing call transfer')
      return (
        <div className="flex items-center gap-1">
          <PhoneTransferIcon className="h-4 w-4 text-brand-text" />
          {isMinimized ? null : (
            <span>
              Call transfer from <span className="text-xs-600">{fromAgent}</span>
            </span>
          )}
        </div>
      )
    if (meta === 'Monitored Call')
      return (
        <div className="flex items-center gap-1">
          <PhoneIncomingIcon className="h-4 w-4 text-brand-text" />
          {isMinimized ? null : <span>Monitored call</span>}
        </div>
      )
    return (
      <div className="flex items-center gap-1">
        <PhoneIncomingIcon className="h-4 w-4 text-brand-text" />
        {isMinimized ? null : <span>Incoming call</span>}
      </div>
    )
  }

  if (isMinimized) return getCallTitle()

  return (
    <div className="flex gap-2 items center justify-between">
      <div className="text-secondary text-xs-400">{getCallTitle()}</div>
      {teamName && (
        <div className="text-xs-400 text-tertiary flex items-center gap-1">
          <Users size={16} />
          <div className="text-secondary">{teamName}</div>
        </div>
      )}
    </div>
  )
}
